import React, { useState } from 'react';
import AcademicYearsTab from '../components/academic/AcademicYearsTab';
import AcademicSessionsTab from '../components/academic/AcademicSessionsTab';
import { useAuth } from '../context/AuthContext';

const tabs = [
  { id: 'years', label: 'ACADEMIC YEAR', icon: '📅' },
  { id: 'sessions', label: 'ACADEMIC SESSION', icon: '📋' },
];

function AcademicSession() {
  const [activeTab, setActiveTab] = useState('years');
  const { user } = useAuth();

  return (
    <div className="page-card">
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="settings-tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="settings-content">
        {activeTab === 'years' && <AcademicYearsTab tenantId={user?.tenantId} />}
        {activeTab === 'sessions' && <AcademicSessionsTab tenantId={user?.tenantId} />}
      </div>
    </div>
  );
}

export default AcademicSession;
